import { render, staticRenderFns } from "./addComment.vue?vue&type=template&id=5c5ca5c0&"
import script from "./addComment.vue?vue&type=script&lang=js&"
export * from "./addComment.vue?vue&type=script&lang=js&"
import style0 from "./addComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports